import React, { useEffect, useState } from 'react';
import TextBox from '../component/textbox';
import Submit from '../component/submit';
import { baseUrl } from '../library/comoda';

const Login: React.FC = () => {
  const [Utente, setUtente] = useState('');
  const [Password, setPassword] = useState('');
  const [StatoResponse, setStatoResponse] = useState<any>(null);
  const [msg, setMsg] = useState<'ok' | 'ko'>('ok');

  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (StatoResponse?.token) {
      localStorage.setItem('token', StatoResponse.token);
      localStorage.setItem('utente', Utente);
    }
    if (StatoResponse?.loggato) window.location.href = StatoResponse.parametri.homepage;
    setMsg(StatoResponse?.loggato === false ? 'ko' : 'ok');
  }, [StatoResponse,Utente]);

  return (
    <>
      <div className="box background altezzafissa">
        <form>
          <span className="text-center">Login</span>

          <div className="input-container">
            <TextBox id="1" name="nome" placeholder="Nome Utente" setValore={setUtente} valore="" />
          </div>

          <div className="input-container">
            <TextBox
              id="2"
              name="password"
              placeholder="Password"
              type="password"
              setValore={setPassword}
              valore=""
            />
          </div>

          <Submit
            id="3"
            value="Login"
            classe="btn"
            endpoint={`${baseUrl}endpoint.php`}
            campi={{ Utente, Password }}
            setStatoResponse={setStatoResponse}
          />

          {msg === 'ko' && (
            <p className="errore" style={{ marginTop: 20 }}>
              <u className="Link" onClick={() => setShowModal(true)} style={{ cursor: 'pointer' }}>
                dimenticato la password?
              </u>
            </p>
          )}
        </form>
      </div>
      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <h3>E così hai perso la password...</h3>
            <p>
             Bravo pirla, scrivi al Davide per fartela resettare, e salvala nel browser la prossima volta.
            </p>
            <button className="btn" onClick={() => setShowModal(false)}>
              Chiudi
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Login;
